import { del, get, jsonParser, post, put } from "./Client";

export const getUser = (user) => 
  get(`/users/${user.id}`).then(jsonParser);

export const searchUser = (query, all = false, page = 0) =>
  get(`/users?query=${query}&all=${all ? "true" : "false"}&page=${page}`)
  .then(jsonParser);

export const checkEmail = (email) =>
  get(`/users/checkemail/${email}`).then(jsonParser);

export const createUser = (user) =>
  post("/users", { body: user }).then(jsonParser);

export const updateUser = (user) =>
  put(`/users/${user.id}`, { body: user }).then(jsonParser);

export const deleteUser = (user) => 
  del(`/users/${user.id}`).then(jsonParser);
